<template>
    <div class="result">
        <div class="inp__block">
            <input type="email" class="search__inp" placeholder="Email" v-model.trim="person.email">
            <span>+7 <input type="tel" class="search__inp" placeholder="Номер телефона без +7"  v-model.trim="person.phone"></span>
            <input type="text" class="search__inp" placeholder="ID клиента" v-model.trim="person.id_client">
            <select class="search__inp" v-model="person.is_active">
                <option value="false">Не активный</option>
                <option value="true">Активный</option>
            </select>
        </div>
        <button class="search__btn" @click="editForm">Редактировать</button>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    props: {
        person: {
            type: Object,
            default: function () {
                return {
                    id: '',
                    email: '',
                    phone: '',
                    id_client: '',
                    is_active: ''
                }
            }
        }
    },
    methods: {
        ...mapActions({
            updatePersonalData: 'admin/updatePersonalData'
        }),
        editForm() {
            let { id, email, phone, id_client, is_active } = this.person
            // if (phone.startsWith("+7") && phone.includes("(")){
            //     phone = phone.replace(/\s+/g, '').replace('(', '').replace(')', '').slice(2);
            // }
            let updatedData = {
                id: id,
                email: email,
                phone: phone,
                id_client: id_client,
                is_active: String(is_active) === 'false' ? false : true
            }
            this.updatePersonalData(updatedData).then((resp) => {
                if (resp === 201){
                    toastr.success(this.$t("editSuccess"));
                    // this.updateData()
                }else if(resp === 200){
                    toastr.warning("Данные не изменены");
                }else{
                    toastr.error(this.$t("isError"));
                }
            })
        },
        // updateData(){
        //     this.$emit('updateData');
        // }
    }
}
</script>
<style scoped>
.result{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.result__block{
    display: flex;
    flex-direction: column;
    padding: 10px;
    row-gap: 10px;
}
.inp__block{
    display: flex;
    column-gap: 10px;
}
.inp__block span{
    color: #717171;
}
.search__inp{
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    padding: 5px 10px;
    color: #464646;
}
.search__btn{
    background-color: #274fd4;
    padding: 5px 20px;
    border-radius: 3px;
    color: #fff;
    transition: all .2s ease-in-out;
}
.search__btn:hover{
    background-color: #1f3a96;
}

</style>